import { useCallback } from "react";
import { useDispatch } from "react-redux";

import { AppDispatch } from "store/store";

import { initialize, setCategory } from "./documentsStore";
import { DocumentCategory } from "./types";

export interface UseDocumentsStore {
  initialize: () => void;
  setCategory: (option: DocumentCategory | null) => void;
}

export const useDocumentsStore = (): UseDocumentsStore => {
  const dispatch = useDispatch<AppDispatch>();

  return {
    initialize: useCallback(() => dispatch(initialize()), [dispatch]),
    setCategory: useCallback(
      (option: { label: string; value: string | number } | null) =>
        dispatch(
          setCategory(
            option ? { label: option.label, value: String(option.value) } : null
          )
        ),
      [dispatch]
    ),
  };
};
